import React from "react";
import Spinner from "../../../../componentLibrary/Spinner";

interface LoadingWrapperProps {
  loading: boolean;
  children: React.ReactNode;
  /** Extra classes on the spinner container. Defaults to "py-4". */
  className?: string;
}

const LoadingWrapper: React.FC<LoadingWrapperProps> = ({
  loading,
  children,
  className = "py-4",
}) => {
  if (loading) {
    return (
      <div className={`flex justify-center ${className}`}>
        <Spinner />
      </div>
    );
  }
  return <>{children}</>;
};

export default LoadingWrapper;
